// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel {
    background-color: #e0e0e0;
}

.bond-lc-input {
    padding-bottom: 20px;
}

.form-group select {
    width: 100%;
}

#bond-lc-search-button,
#bond-add-bond-button {
    margin-right: 5px;
}

#beneficiary {
    width: 100%;
}

.bond-lc-from-amounts,
.bond-lc-from-issue-date,
.bond-lc-from-cancel-date,
.bond-lc-to-amounts,
.bond-lc-to-issue-date,
.bond-lc-to-cancel-date {
    display: flex;
}

::ng-deep .p-datatable .p-datatable-header {
    color: black;
    background: #f5f5f5;
    padding: 0;
}

::ng-deep .p-datatable-thead > tr > th {
    background-color: silver !important;
    font-size: 12px;
    white-space: normal;
    text-align: center;
    vertical-align: middle;
}

::ng-deep .p-datatable-table {
    width: 100%;
    table-layout: auto;
}

::ng-deep .p-datatable-wrapper {
    overflow-x: hidden;
}

.header-label {
    font-size: 16px;
    margin-bottom: 10px;
}

.no-overflow {
    overflow: hidden;
}

::ng-deep .col-gap {
    padding-left: 20px !important;
}

::ng-deep .col-gap + .col-gap {
    padding-left: 32px !important;
}

::ng-deep .well > .col-md-4 .form-group:not(.row) {
    margin-bottom: 6px;
}

::ng-deep .col-gap .form-group.row > .col-6.nested-spacings:first-child {
    padding-right: 0 !important;
}

::ng-deep .col-gap .form-group.row > .col-6.nested-spacings + .col-6.nested-spacings {
    padding-left: 20px !important;
}

label {
    font-size: 14px;
}

.form-group label {
    display: block;
    margin-bottom: 2px;
}

.form-group br {
    display: none;
}

::ng-deep .p-datatable-tbody {
    font-size: 12px;
    overflow-wrap: break-word;
}

::ng-deep .p-datatable .p-datatable-header {
    border: none;
}

::ng-deep .p-datatable .p-datatable-tbody > tr > td {
    padding: .5rem;
}

.modal-button {
    margin-left: 0;
}

.well {
    border: solid 1px #d3d3d3;
    margin: 5px;
}

h2 {
    margin: 5px 5px 15px 5px;
}

.results-table {
    border: none;
    margin: 5px;
}

.important-note span {
    color: red;
}

.nested-spacings {
    padding: 0px 5px 0px 0px !important;
    margin: 0px 0px 4px 0px !important
}

`, "",{"version":3,"sources":["webpack://./src/app/search-bond/search-bond.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;IAMI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC;AACJ","sourcesContent":[".main-panel {\r\n    background-color: #e0e0e0;\r\n}\r\n\r\n.bond-lc-input {\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.form-group select {\r\n    width: 100%;\r\n}\r\n\r\n#bond-lc-search-button,\r\n#bond-add-bond-button {\r\n    margin-right: 5px;\r\n}\r\n\r\n#beneficiary {\r\n    width: 100%;\r\n}\r\n\r\n.bond-lc-from-amounts,\r\n.bond-lc-from-issue-date,\r\n.bond-lc-from-cancel-date,\r\n.bond-lc-to-amounts,\r\n.bond-lc-to-issue-date,\r\n.bond-lc-to-cancel-date {\r\n    display: flex;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-header {\r\n    color: black;\r\n    background: #f5f5f5;\r\n    padding: 0;\r\n}\r\n\r\n::ng-deep .p-datatable-thead > tr > th {\r\n    background-color: silver !important;\r\n    font-size: 12px;\r\n    white-space: normal;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\n::ng-deep .p-datatable-table {\r\n    width: 100%;\r\n    table-layout: auto;\r\n}\r\n\r\n::ng-deep .p-datatable-wrapper {\r\n    overflow-x: hidden;\r\n}\r\n\r\n.header-label {\r\n    font-size: 16px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.no-overflow {\r\n    overflow: hidden;\r\n}\r\n\r\n::ng-deep .col-gap {\r\n    padding-left: 20px !important;\r\n}\r\n\r\n::ng-deep .col-gap + .col-gap {\r\n    padding-left: 32px !important;\r\n}\r\n\r\n::ng-deep .well > .col-md-4 .form-group:not(.row) {\r\n    margin-bottom: 6px;\r\n}\r\n\r\n::ng-deep .col-gap .form-group.row > .col-6.nested-spacings:first-child {\r\n    padding-right: 0 !important;\r\n}\r\n\r\n::ng-deep .col-gap .form-group.row > .col-6.nested-spacings + .col-6.nested-spacings {\r\n    padding-left: 20px !important;\r\n}\r\n\r\nlabel {\r\n    font-size: 14px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.form-group br {\r\n    display: none;\r\n}\r\n\r\n::ng-deep .p-datatable-tbody {\r\n    font-size: 12px;\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-header {\r\n    border: none;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n    padding: .5rem;\r\n}\r\n\r\n.modal-button {\r\n    margin-left: 0;\r\n}\r\n\r\n.well {\r\n    border: solid 1px #d3d3d3;\r\n    margin: 5px;\r\n}\r\n\r\nh2 {\r\n    margin: 5px 5px 15px 5px;\r\n}\r\n\r\n.results-table {\r\n    border: none;\r\n    margin: 5px;\r\n}\r\n\r\n.important-note span {\r\n    color: red;\r\n}\r\n\r\n.nested-spacings {\r\n    padding: 0px 5px 0px 0px !important;\r\n    margin: 0px 0px 4px 0px !important\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
